import type { RouteObject } from 'react-router-dom';
import { NOTIFICATION_CHANNELS, NOTIFICATION_CODES } from '@app/shared';
import { RequirePermission } from '../auth/guards';
import {
  CampaignAttachPage,
  CampaignCreatePage,
  CampaignEditPage,
  CampaignListPage,
} from './CampaignPages';
import {
  NotificationAddPage,
  NotificationEditPage,
  NotificationListPage,
} from './NotificationPages';

const guard = (code: string, element: JSX.Element) => (
  <RequirePermission code={code}>{element}</RequirePermission>
);

/** Notifications (PC677): add, list and change, per channel. Campaigns (PC760). */
export const messagingRoutes: RouteObject[] = [
  ...NOTIFICATION_CHANNELS.flatMap((channel) => [
    {
      path: `notifications/${channel}`,
      // `key` gives each channel its own filters and paging.
      element: guard(
        NOTIFICATION_CODES[channel].view,
        <NotificationListPage key={channel} channel={channel} />,
      ),
    },
    // The add and edit pages check their own code.
    {
      path: `notifications/${channel}/new`,
      element: <NotificationAddPage key={channel} channel={channel} />,
    },
    {
      path: `notifications/${channel}/:id`,
      element: <NotificationEditPage key={channel} channel={channel} />,
    },
  ]),
  { path: 'campaigns', element: guard('PC762', <CampaignListPage />) },
  { path: 'campaigns/new', element: guard('PC761', <CampaignCreatePage />) },
  { path: 'campaigns/attach', element: guard('PC763', <CampaignAttachPage />) },
  { path: 'campaigns/:id', element: guard('PC762', <CampaignEditPage />) },
];
